<template>
  <v-text-field
    :value="cellValue"
    :id="ctrlId"
    prefix="$"
    single-line
    readonly
    height="24"
  ></v-text-field>
</template>

<script>
import { answerService } from "../../services/answerService";
import cellErrorHighlightMixin from "./mixins/cellErrorHighlightMixin.js";

export default {
  name: "ComputationCell",
  mixins: [cellErrorHighlightMixin],

  props: {
    id: String,
    name: String,
    index: Number,
    op: String,
    fields: Array,
    value: Number,
    subHeader: String,
    disabled: Boolean,
    rowLabel: String
  },

  data () {
    return {
      theValue: { value: 0, strValue: "" }
    };
  },

  mounted () {
    const raw = this.value != null ? this.value : null;
    this.theValue = answerService.getAnswerValue(raw);

    if (this.theValue.value === Number.MIN_SAFE_INTEGER) {
      this.$emit("update:disable", true);
    }

    this.onValueChanged();
  },

  computed: {
    ctrlId () {
      return `${this.name}_${this.index}_${this.id}`;
    },

    cellValue () {
      return this.theValue?.strValue || "";
    }
  },

  watch: {
    value (newVal) {
      if (!this.theValue) return;

      this.theValue.value = newVal;
      this.onValueChanged();
    },

    disabled (newVal) {
      if (!this.theValue) return;

      if (newVal) {
        this.theValue.value = Number.MIN_SAFE_INTEGER;
      } else {
        this.theValue.value = 0;
      }

      this.onValueChanged();
    }
  },

  methods: {
    onValueChanged () {
      this.$emit("update", {
        answerId: this.name,
        index: this.index,
        value: this.theValue.value,
        subHeader: this.subHeader
      });
    }
  }
};
</script>

<style scoped>
.v-text-field >>> input {
  text-align: right;
  padding: 3px;
}
</style>
